import { render, staticRenderFns } from "./oilList.vue?vue&type=template&id=216d8d02&"
import script from "./oilList.vue?vue&type=script&lang=js&"
export * from "./oilList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports